import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router/index';
import store from './store/store';
import vuetify from './plugins/vuetify';
import vueDebounce from 'vue-debounce';
import {formatAmount} from './helper/amount';

Vue.config.productionTip = false;
Vue.use(vueDebounce);
Vue.use(require('vue-moment'));

Vue.filter('amount', formatAmount);

Vue.filter('uppercase', function (value) {
  return value.toUpperCase()
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
